var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"node-process-table\">\n<h4>Process</h4>\n<table class=\"table table-condensed table-hover table-striped\">\n<tbody>\n<tr>\n<td>CPU percent</td>\n<td>{{nPTableCtrl.process.cpu.percent / 100 | numeral: '0[.][0][0] %'}}</td>\n</tr>\n<tr>\n<td>File Descriptors</td>\n<td>{{nPTableCtrl.process.max_file_descriptors | numeral: '0[.][0][0] a'}}</td>\n</tr>\n<tr>\n<td>Open File Descriptors</td>\n<td>{{nPTableCtrl.process.open_file_descriptors | numeral: '0[.][0][0] a'}}</td>\n</tr>\n<tr>\n<td>MLockAll</td>\n<td>{{nPTableCtrl.info.mlockall}}</td>\n</tr>\n<tr>\n<td>Virtual Memory</td>\n<td>{{nPTableCtrl.process.mem.total_virtual_in_bytes | numeral: '0[.][0][0] b'}}</td>\n</tr>\n<tr>\n<td>Current Time</td>\n<td>{{nPTableCtrl.process.timestamp | moment }}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="components/node-process-table/node-process-table.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/node-process-table/node-process-table.template.html
// module id = 934
// module chunks = 0